


















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import MakeOptionWithLogoAndCount from '~/components/car/classifieds/search/facets/handlers/MakeModel/MakeOptionWithLogoAndCount.vue'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import CCustomOptionGroupsSelect from '~/components/shared/configurable/form/select/custom/CCustomOptionGroupsSelect.vue'
import COptionWithCount from '~/components/shared/configurable/form/option/COptionWithCount.vue'
import { CategoryId } from '~/models/category/types'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'

export default Vue.extend({
  components: {
    CCustomSelect,
    MakeOptionWithLogoAndCount,
    CCustomOptionGroupsSelect,
    COptionWithCount
  },

  props: {
    options: { type: Array, required: true },
    groupOptions: { type: Array, default: () => [] },
    topOptions: { type: Array, default: () => [] },
    placeholder: { type: String, default: null },
    title: { type: String, default: null },
    withMakeLogo: { type: Boolean, default: false },
    multiSelect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    selectedId: { type: [Array, Number], default: null },
    groupSelect: { type: Boolean, default: false },
    valueField: { type: String, default: 'id' },
    textField: { type: String, default: 'name' },
    categoryId: { type: Number, default: null }
  },
  data() {
    return {
      selectedOption: this.selectedId,
      searchTextExists: null
    }
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    MakesOptionComponent() {
      if (CategoryId.CARS === this.categoryId) {
        return MakeOptionWithLogoAndCount
      }
      return COptionWithCount
    },
    mergedOptions(): [] {
      if (this.isMobile) {
        const optionsArray = this.options?.length
          ? this.options
          : this.groupOptions
        const options = []
        optionsArray.forEach(o => {
          if (!this.topOptions.find(t => t.id === o.id)) {
            options.push(o)
          }
        })
        return this.topOptions.concat(options) as []
      }
      return this.searchTextExists
        ? this.options
        : this.topOptions.concat(this.options)
    },

    normalizedGroupOptions() {
      if (this.isMobile && this.options.length) {
        return this.options
      }
      return this.groupOptions
    },
    topOptionsLength(): number {
      return this.topOptions.length - 1
    }
  },
  watch: {
    selectedId() {
      this.selectedOption = this.selectedId
    }
  },
  methods: {
    handleSearchChange(search: string) {
      this.searchTextExists = Boolean(search && search.length)
    },
    clearSelected() {
      this.selectedOption = null
    }
  }
})
